(function() {
    $(document).ready(function() {
        $('a.zoom').fancybox({});
    });
})();

